// src/js-coding/Homepage.js
import React from "react";
import "../css-coding/Homepage.css"; // ✅ Homepage styles

// ✅ Import sections/components
import HeroSection from "./HeroSection";
import ClientSection from "./ClientSection";
import LogoMarquee from "./LogoMarquee";
import ServiceSlider from "./ServiceSlider";
import VideoReels from "./VideoReels";
import ProcessSection from "./ProcessSection";
import TestimonialSection from "./TestimonialSection";
import FaqAccordion from "./FaqAccordion";
import ContactSection from "./ContactSection";
import Footer from "./Footer";  // ✅ Correct (relative import)
import ClientD from "./ClientSectionD";
import Number from "./numbers";


// ✅ Import assets
import tgs from "../assets/tgs.mp4";

const Homepage = () => {
  return (
    <div>
      {/* ✅ Hero Section */}
      <HeroSection />

      {/* ✅ Video Section */}
      <div className="video-container">
        <div className="video-wrapper">
          <video
            className="video-frame"
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={tgs} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      <br></br>
      <br></br>
      <br></br>
      <br></br>

      {/* ✅ Other Sections */}
      <div className="section-container client-section">
          <ClientD/>
        <ClientSection />
      
      </div>
      <div className="section-container logo-marquee">
        <LogoMarquee />
      </div>
      <div className="section-container service-slider">
        <ServiceSlider />
      </div>
      <VideoReels />
      <ProcessSection />
      <TestimonialSection />
     <Number></Number>
      <FaqAccordion />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Homepage;
